import $ from "jquery"
import './../scss/style.scss';
//  import Bootstrap
window.jQuery = window.$ = $;
require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap');
// require('bootstrap');

import { trace, UiHelpers } from "./shared/helpers";
import Dir from "./shared/Dir";
import FormValidator from "./shared/FormValidator";
import ImageGallery from "./shared/ImageGallery";
import StoartBgCarousel from "./home/StoartBgCarousel";
import AlertBox from "./home/AlertBox";
import Maps from "./shared/Maps";
import OpenInModal from "./shared/OpenInModal";
import Resizer from "./shared/Resizer";
import SIV from "./shared/SIV";




$(() => {
  UiHelpers.init();
  FormValidator.init();
  StoartBgCarousel.init();
  AlertBox.init();
  Dir.init();
  ImageGallery.init();
  OpenInModal.init();
  // Resizer.init();
  SIV.init();
  // initial modal
  const openingModal = document.querySelector(".modal-opening .modal")
  if (openingModal) {
    $(openingModal).modal()
  }
});

$(window).on( "load", ()=> {
  Maps.init();
  SIV.update();
});